const Modal = ({
    isVisible,
    children,
}) => {
    return isVisible ? (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md mx-auto text-center">
        {children}
      </div>
    </div>
    ) : null;
}

export default Modal;